module.exports = __webpack_public_path__ + "img/fbcg.07a6f1f.png";